export enum WatchlistCureType {
    BroughtCurrent = 1,
    Extended = 2,
    Repaid = 3,
    RepaidAllInterestAndFees = 4,
    NoUnapprovedLiens = 5,
    ClearTitle = 6,
    LitigationResolved = 7,
    LoanRepayment = 8,
    Complet95PercentOrCertificateOfOccupany = 9,
    Other = 10,
}

export const WatchlistCureTypeOptions = [
    {
        id: WatchlistCureType.BroughtCurrent,
        name: 'Brought Current',
    },
    {
        id: WatchlistCureType.Extended,
        name: 'Extended',
    },
    {
        id: WatchlistCureType.Repaid,
        name: 'Repaid',
    },
    {
        id: WatchlistCureType.RepaidAllInterestAndFees,
        name: 'Repaid all Interest and Fees',
    },
    {
        id: WatchlistCureType.NoUnapprovedLiens,
        name: 'No Unapproved Liens',
    },
    {
        id: WatchlistCureType.ClearTitle,
        name: 'Clear Title',
    },
    {
        id: WatchlistCureType.LitigationResolved,
        name: 'Litigation Resolved',
    },
    {
        id: WatchlistCureType.LoanRepayment,
        name: 'Loan Repayment',
    },
    {
        id: WatchlistCureType.Complet95PercentOrCertificateOfOccupany,
        name: 'Complete to 95% or Certificate of Occupancy',
    },
    {
        id: WatchlistCureType.Other,
        name: 'Other',
    },
];
